import dayjs from "dayjs";
import ApplicationAppService from "../../../application/platform/application-app-service";
import { IAuthenticationResponse } from "../../../model/security/response/authentication-response";
import { ACTION_TYPES, useGlobalDispatch } from "./global-context";

export const useGlobalController = () => {
    const globalDispatch = useGlobalDispatch();
    const getApplicationData =  () => {

        try {
            const applicationData = ApplicationAppService.getApplicationData();

            globalDispatch({
                type: ACTION_TYPES.setApplicationData,
                payload: applicationData,
            });
        } catch (error) {
            console.log(error);
        }
    }
    const setAuthenticationData =  (authenticationResponse: IAuthenticationResponse) => {
        try {
            var result =  ApplicationAppService.setAuthenticationData(authenticationResponse);
  
            globalDispatch({
                type: ACTION_TYPES.setAuthenticationData,
                payload: result,
            });
        } catch (error) {
            console.log(error);
        }
    }


    return {
        getApplicationData, setAuthenticationData
    };
}